import type { CtaBlockModel } from '@site/shared'
import { LocaleLink as Link } from '@/components/LocaleLink'
import { analytics } from '@/lib/analytics'

/** Closing call-to-action: headline, sub-headline, one button. */
export function CtaSection({ block }: { block: CtaBlockModel }) {
  const { headline, subheadline, buttonLabel, buttonHref } = block
  const onClick = () => analytics.ctaClick(buttonLabel, buttonHref)

  return (
    <section className="block cta">
      <div className="wrap wrap-narrow cta-inner">
        <h2 className="h2">{headline}</h2>
        {subheadline && <p className="lede">{subheadline}</p>}
        {buttonHref.startsWith('/') ? (
          <Link to={buttonHref} className="btn btn-primary" onClick={onClick}>{buttonLabel}</Link>
        ) : (
          <a href={buttonHref} className="btn btn-primary" onClick={onClick}>{buttonLabel}</a>
        )}
      </div>
    </section>
  )
}
